import { RecoilRoot } from "recoil";
import AppRoutes from "./routes/AppRoutes";
import { DataProvider } from "./utils/context";

const App = () => {
      return (
        <DataProvider>
            <AppRoutes />
        </DataProvider>
    );
};

export default App;
